import { startingLineup } from '@shared/depthChart.js';
import { positions } from '@/utils/positions';

// Starting spots that won't go to the listed starter next game (injuries,
// or a backup moving over to fill in), worked out with the sim's own rule.
// Returns [{posId, text}].
export function lineupChanges(players, depth) {
    const name = (p) => `${p.fName} ${p.lName}`;
    const lineup = startingLineup(players, depth);
    const changes = [];
    positions.forEach((pos, slot) => {
        const listed = players[depth?.[`${pos.id}_0`]];
        const actual = players[lineup[slot]];
        if (!listed || !actual || listed.id === actual.id) return;
        const movedTo = positions[lineup.indexOf(listed.id)];
        changes.push({
            posId: pos.id,
            text: listed.injury?.gamesOut > 0 ?
                `Your ${pos.short} ${name(listed)} is out (${listed.injury.gamesOut} more), so ${name(actual)} will start there.` :
                `${name(listed)} is filling in at ${movedTo?.short}, so ${name(actual)} will start at ${pos.short}.`,
        });
    });
    return changes;
}
